import { ApiHelper, Mapper } from 'src/utils';
import ApiConfig from './ApiConfig';
import { ApiResultDTO, NotificationClient_V1, NotificationRegistrationDTO, UserNotificationDTO } from './generated/api.generated.v1';

export default class NotificationService {
    private readonly _notificationClient: NotificationClient_V1;

    constructor() {
        this._notificationClient = new NotificationClient_V1(new ApiConfig(), process.env.VUE_APP_API_V1_URL);
    }

    private static instance: NotificationService;

    public static GetInstance() : NotificationService {
        if (!NotificationService.instance) {
            NotificationService.instance = new NotificationService();
        }

        return NotificationService.instance;
    }

    public RegisterToken(userId: string, pushToken: string, firebaseToken: string, platform: string, companyType: string) : Promise<NotificationRegistrationDTO> {
        const dto = new NotificationRegistrationDTO();
        dto.userId = userId;
        dto.pushToken = pushToken;
        dto.firebaseToken = firebaseToken;
        dto.devicePlatformType = Mapper.MapDevicePlatformType(platform);
        dto.companyType = Mapper.MapCompanyType(companyType);

        return ApiHelper.ParseDTO<NotificationRegistrationDTO>(() => this._notificationClient.registerToken(dto));
    }

    public async GetUserNotifcations() : Promise<Array<UserNotificationDTO>>{
        return await this._notificationClient.userNotifications();
    }

    public async SetUserNotifcationRead(userNotificationId : string) : Promise<void>{
        return await this._notificationClient.notificationRead(userNotificationId);
    }

    public async DeleteNotificationByUid(userNotificationId : string) : Promise<ApiResultDTO> {
        return await this._notificationClient.deleteNotification(userNotificationId);
    }
}